<template>
  <div class="slider hero__slider">
    <ul class="slider__list">
      <li class="slider__list-item" v-for="(image, index) of images" :key="index">
        <img class="slider__image" :src="image.url" />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    images: {
      type: Array,
      required: true
    }
  }
};
</script>
